import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { service } from "@modules/newCommunity/setup";
import commonService from "@/commonService/index";
import { randomNumber } from "@/utils/commonUtil";
/** 医院等级展示中文名称，选择器与匹配配置均保存对应字母。 */
const HOSPITAL_LEVEL_OPTIONS = [{
  label: "特级",
  value: "A"
}, {
  label: "三级甲等",
  value: "B"
}, {
  label: "三级乙等",
  value: "C"
}, {
  label: "三级丙等",
  value: "D"
}, {
  label: "二级甲等",
  value: "E"
}, {
  label: "二级乙等",
  value: "F"
}, {
  label: "二级丙等",
  value: "G"
}, {
  label: "一级甲等",
  value: "H"
}, {
  label: "一级乙等",
  value: "I"
}, {
  label: "一级丙等",
  value: "J"
}, {
  label: "未知",
  value: "K"
}, {
  label: "民营医院",
  value: "L"
}, {
  label: "未评级",
  value: "M"
}, {
  label: "一级",
  value: "N"
}, {
  label: "二级",
  value: "O"
}, {
  label: "三级",
  value: "P"
}];
let ParticipantAutoFillConfig = class ParticipantAutoFillConfig extends Vue {
  constructor() {
    super(...arguments);
    this.departmentOptions = [];
    this.professionList = [];
    this.departmentLoading = false;
    this.professionLoading = false;
    this.departmentLoaded = false;
    this.professionLoaded = false;
    this.departmentLoadError = false;
    this.professionLoadError = false;
    this.departmentProps = {
      multiple: true,
      checkStrictly: false,
      emitPath: false,
      value: "id",
      label: "name",
      children: "childList"
    };
    // 职业类型作为一级节点，具体职称作为二级节点。
    this.professionProps = {
      multiple: true,
      checkStrictly: false,
      emitPath: true,
      value: "value",
      label: "label",
      children: "children"
    };
    this.hospitalLevelOptions = HOSPITAL_LEVEL_OPTIONS;
  }
  get config() {
    return this.form && this.form.jsonConfig ? this.form.jsonConfig.participantAutoFillConfig || {} : {};
  }
  get isTextOption() {
    return this.form && this.form.optionContentType === "TEXT";
  }
  get currentDataLoading() {
    return this.config.fieldType === "DEPARTMENT" && this.departmentLoading || this.config.fieldType === "PROFESSIONAL_TITLE" && this.professionLoading;
  }
  get currentDataError() {
    return this.config.fieldType === "DEPARTMENT" && this.departmentLoadError || this.config.fieldType === "PROFESSIONAL_TITLE" && this.professionLoadError;
  }
  // 将活动参与规则中的职业职称树转换为联级选择器数据。
  get professionOptions() {
    return this.professionList.map(profession => ({
      value: profession.professionType,
      label: profession.professionName,
      children: (profession.titleList || []).map(title => ({
        value: title,
        label: title
      }))
    }));
  }
  handleFormChange() {
    this.ensureConfig();
    this.syncOptionMappings();
    this.loadSavedFieldData();
  }
  handleOptionContentTypeChange(optionContentType) {
    // 图片选项不支持该能力，保留已配映射但停止启用。
    if (optionContentType === "IMAGE" && this.config.enabled) this.config.enabled = false;
  }
  ensureConfig() {
    if (!this.form) return;
    if (!this.form.jsonConfig) this.$set(this.form, "jsonConfig", {});
    if (!this.form.jsonConfig.participantAutoFillConfig) {
      this.$set(this.form.jsonConfig, "participantAutoFillConfig", {
        enabled: false,
        fieldType: null,
        optionMappings: []
      });
    }
    const config = this.form.jsonConfig.participantAutoFillConfig;
    if (typeof config.enabled !== "boolean") this.$set(config, "enabled", false);
    if (config.fieldType === undefined) this.$set(config, "fieldType", null);
    if (!Array.isArray(config.optionMappings)) this.$set(config, "optionMappings", []);
    this.ensureOptionIds();
  }
  ensureOptionIds() {
    if (!this.form || !Array.isArray(this.form.optionsList)) return;
    this.form.optionsList.forEach(option => {
      // 新建题目的初始选项没有 ID 时补充临时 ID，供映射在首次保存前稳定关联。
      if (option.id === undefined || option.id === null || option.id === "") {
        this.$set(option, "id", Number(`1${randomNumber(6)}`) * -1);
      }
    });
  }
  syncOptionMappings() {
    if (!this.form || !this.config.enabled || !this.config.fieldType || !Array.isArray(this.form.optionsList)) return;
    const optionIds = this.form.optionsList.map(option => option.id);
    const mappings = this.config.optionMappings.filter(mapping => optionIds.includes(mapping.optionId));
    this.form.optionsList.forEach(option => {
      if (!mappings.some(mapping => mapping.optionId === option.id)) mappings.push({
        optionId: option.id,
        matchValues: [],
        selectorValues: []
      });
    });
    const changed = mappings.length !== this.config.optionMappings.length || mappings.some((mapping, index) => mapping !== this.config.optionMappings[index]);
    if (changed) this.$set(this.config, "optionMappings", mappings);
  }
  getMapping(optionId) {
    let mapping = this.config.optionMappings.find(item => item.optionId === optionId);
    if (!mapping) {
      mapping = {
        optionId,
        matchValues: [],
        selectorValues: []
      };
      this.config.optionMappings.push(mapping);
    }
    return mapping;
  }
  handleEnabledChange(enabled) {
    if (enabled && this.config.fieldType) {
      this.syncOptionMappings();
      this.loadCurrentFieldData();
    }
  }
  handleFieldTypeChange() {
    // 切换字段后原标准值语义已失效，直接清空全部选项映射。
    this.$set(this.config, "optionMappings", []);
    this.syncOptionMappings();
    this.loadCurrentFieldData();
  }
  // 编辑页回填已开启的配置时，按已保存字段类型主动加载选择器数据。
  loadSavedFieldData() {
    if (!this.config.enabled || !this.config.fieldType) return;
    if (this.config.fieldType === "DEPARTMENT" && !this.departmentLoaded && !this.departmentLoading && !this.departmentLoadError) {
      this.loadDepartmentOptions();
    } else if (this.config.fieldType === "PROFESSIONAL_TITLE" && !this.professionLoaded && !this.professionLoading && !this.professionLoadError) {
      this.loadProfessionOptions();
    }
  }
  async loadCurrentFieldData() {
    if (this.config.fieldType === "DEPARTMENT") {
      await this.loadDepartmentOptions();
    } else if (this.config.fieldType === "PROFESSIONAL_TITLE") {
      await this.loadProfessionOptions();
    }
  }
  async loadDepartmentOptions() {
    if (this.departmentLoading || this.departmentLoaded) return;
    this.departmentLoading = true;
    this.departmentLoadError = false;
    try {
      const res = await commonService.findDepartmentHierarchyList({});
      if (res.code === 200) {
        this.departmentOptions = res.data || [];
        this.departmentLoaded = true;
      } else {
        this.departmentLoadError = true;
      }
    } catch (error) {
      this.departmentLoadError = true;
    } finally {
      this.departmentLoading = false;
    }
  }
  async loadProfessionOptions() {
    if (this.professionLoading || this.professionLoaded) return;
    this.professionLoading = true;
    this.professionLoadError = false;
    try {
      const res = await service.getActivityProfessionTitleTree({});
      if (res.code === 200) {
        this.professionList = res.data || [];
        this.professionLoaded = true;
      } else {
        this.professionLoadError = true;
      }
    } catch (error) {
      this.professionLoadError = true;
    } finally {
      this.professionLoading = false;
    }
  }
  // 从联级路径提取职称名称，供后端按扁平数组匹配。
  getProfessionMatchValues(selectorValues) {
    const matchValues = selectorValues.reduce((values, value) => {
      if (!Array.isArray(value) || !value[1] || values.includes(value[0] + "-" + value[1])) return values;
      values.push(value[0] + "-" + value[1]);
      return values;
    }, []);
    return matchValues;
  }
  // 保存联级路径用于回显，同时将职称打平后提供给后端匹配。
  handleProfessionalCascaderChange(optionId, selectedValues) {
    const mapping = this.getMapping(optionId);
    mapping.selectorValues = selectedValues || [];
    mapping.matchValues = this.getProfessionMatchValues(mapping.selectorValues);
  }
  // 科室 ID、医院等级字母可直接作为后台匹配值保存。
  handleFlatSelectorChange(optionId, selectedValues) {
    const mapping = this.getMapping(optionId);
    mapping.matchValues = [...(selectedValues || [])];
  }
  validateFieldType(rule, value, callback) {
    if (this.config.enabled && !value) {
      callback(new Error("请选择匹配参与者信息字段"));
    } else {
      callback();
    }
  }
  validateOptionMappings(rule, value, callback) {
    if (!this.config.enabled) return callback();
    const mappings = Array.isArray(value) ? value : [];
    if (!mappings.some(mapping => mapping.matchValues && mapping.matchValues.length > 0)) return callback(new Error("请至少为一个选项配置参与者信息"));
    const mappedValueOptionIds = new Map();
    for (const mapping of mappings) {
      for (const key of this.getMappingValueKeys(mapping.matchValues || [])) {
        if (mappedValueOptionIds.has(key) && mappedValueOptionIds.get(key) !== mapping.optionId) return callback(new Error("该参与者信息已匹配其他选项"));
        mappedValueOptionIds.set(key, mapping.optionId);
      }
    }
    callback();
  }
  getMappingValueKeys(values) {
    return values.map(value => `${this.config.fieldType}:${value}`);
  }
};
__decorate([Prop({
  type: Object,
  required: true
})], ParticipantAutoFillConfig.prototype, "form", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], ParticipantAutoFillConfig.prototype, "disabled", void 0);
__decorate([Watch("form", {
  deep: true,
  immediate: true
})], ParticipantAutoFillConfig.prototype, "handleFormChange", null);
__decorate([Watch("form.optionContentType")], ParticipantAutoFillConfig.prototype, "handleOptionContentTypeChange", null);
ParticipantAutoFillConfig = __decorate([Component({
  name: "participantAutoFillConfig"
})], ParticipantAutoFillConfig);
export default ParticipantAutoFillConfig;